import pako from 'pako';

export function decompressImage(compressedData: string): string {
  // Check for null, undefined, or empty string
  if (!compressedData || compressedData.trim() === '') {
    console.error('Error decompressing image: Input data is null or empty');
    return '';
  }

  try {
    // Convert base64 string to Uint8Array
    const binaryString = atob(compressedData);
    const bytes = new Uint8Array(binaryString.length);
    for (let i = 0; i < binaryString.length; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }
    
    // Decompress using pako.inflate() to match Java's Deflater/Inflater default behavior (zlib format)
    // Java's Deflater() and Inflater() use zlib format by default (nowrap=false)
    const decompressedData = pako.inflate(bytes);
    
    // Check if decompression resulted in empty data
    if (!decompressedData || decompressedData.length === 0) {
      console.error('Error decompressing image: Decompressed data is empty');
      return '';
    }
    
    // Convert Uint8Array back to base64 string
    let binary = '';
    for (let i = 0; i < decompressedData.length; i++) {
      binary += String.fromCharCode(decompressedData[i]);
    }
    return btoa(binary);
  } catch (error) {
    console.error('Error decompressing image:', error);
    return '';
  }
}
